import DataTable from '@components/DataTable';
import { TableWrapper, AnalystsTableWrapper } from './styled';
import { pluralise } from '@utilities/pluralise';
interface AnalystEntity {
  id: string;
  firstName: string;
  lastName: string;
  brokerId: string;
}

interface BrokerEntity {
  id: string;
  name: string;
  analystKeys: string[];
}

interface AnalystsTableProps {
  companyId: string;
  companyName: string;
  analystCount: number;
  analystKeys: string[];
  analystEntities: Record<string, AnalystEntity>;
  brokerEntities: Record<string, BrokerEntity>;
}

const AnalystsTable = ({
  companyName,
  analystKeys,
  analystEntities,
  brokerEntities,
  analystCount,
}: AnalystsTableProps) => {
  return (
    <AnalystsTableWrapper>
      <p>
        {`
          ${companyName} is covered by ${analystKeys.length} ${pluralise(
          analystCount,
          'analyst',
          'analysts'
        )}. ${analystCount} of those analysts submitted the estimates of revenue or earnings used as inputs to our report.
        `}
      </p>
      <TableWrapper>
        <DataTable light>
          <thead>
            <tr>
              <th>Institution</th>
              <th>Analyst</th>
            </tr>
          </thead>
          <tbody>
            {analystKeys
              .map((n) => {
                const analystFirstName = analystEntities[n].firstName || '';
                const analystLastName = analystEntities[n].lastName || '';
                return {
                  brokerName: brokerEntities[analystEntities[n].brokerId].name,
                  analystName: `${analystFirstName} ${analystLastName}`,
                };
              })
              .sort((a, b) =>
                a.brokerName
                  .toLowerCase()
                  .localeCompare(b.brokerName.toLowerCase())
              )
              .map((n, i) => (
                <tr key={`AnalystsTable-${i}-${n.brokerName}`}>
                  <td>{n.brokerName}</td>
                  <td>{n.analystName}</td>
                </tr>
              ))}
          </tbody>
        </DataTable>
      </TableWrapper>
    </AnalystsTableWrapper>
  );
};

export default AnalystsTable;
